import React from 'react';
import { Link } from 'react-router-dom';
import { ContactForm } from './ContactForm';
import { useTheme } from './ThemeProvider';
import { ThemeToggle } from './ThemeToggle';
export function Footer() {
  const year = new Date().getFullYear();
  const {
    theme
  } = useTheme();
  const darkLogo = 'https://cdn.magicpatterns.com/uploads/4dE9fLpUrJZPexP4Wa8YZa/Layer_1.svg';
  // Full-color Yetu logo used on the light theme.
  const lightLogo = 'https://cdn.magicpatterns.com/uploads/vp8wHRm6LNapEACMvi3gx4/yetu_full_color_logo.svg';
  return <>
      <section id="contact" className="sec wrap" data-id="element-76">
        <div className="ctacard text-left grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-77">
          <div data-id="element-78">
            <div className="mk mb-4" data-id="element-79">Let's talk</div>
            <h2 className="!m-0 !max-w-none mb-6" data-id="element-80">
              Let's build something people{' '}
              <span className="serif" data-id="element-81">remember.</span>
            </h2>
            <p className="text-mut text-lg mb-8 max-w-md" data-id="element-82">
              Ready to stand out? Book a free consultation and let's discuss how
              we can fuel your growth with design that works.
            </p>
            <div className="flex flex-col gap-4 text-mut" data-id="element-83">
              <a href="mailto:info@yetudesignlab.com" className="hover:text-lime transition-colors flex items-center gap-3" data-id="element-84">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-85">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" data-id="element-86"></path>
                  <polyline points="22,6 12,13 2,6" data-id="element-87"></polyline>
                </svg>
                info@yetudesignlab.com
              </a>
              <a href="tel:0701922299" className="hover:text-lime transition-colors flex items-center gap-3" data-id="element-88">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-89">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" data-id="element-90"></path>
                </svg>
                0701 922 299
              </a>
            </div>
          </div>
          <div data-id="element-91">
            <ContactForm data-id="element-92" />
          </div>
        </div>
      </section>

      <footer className="ft" data-id="element-93">
        <div className="wrap" data-id="element-94">
          <div className="ft__grid" data-id="element-95">
            <div className="ft__brand" data-id="element-96">
              <Link to="/" className="logo" data-id="element-97">
                <img src={theme === 'light' ? lightLogo : darkLogo} alt="Yetu Design Lab" className="h-12 object-contain transition-opacity duration-300" data-id="element-98" />
              </Link>
              <p data-id="element-99">
                A Nairobi creative studio building brand identities, websites,
                and campaigns for teams who'd rather stand out than blend in.
              </p>
            </div>

            <div data-id="element-100">
              <h5 data-id="element-101">Studio</h5>
              <Link to="/#work" data-id="element-102">Work</Link>
              <Link to="/#studio" data-id="element-103">Studio</Link>
              <Link to="/blog" data-id="element-104">Blog</Link>
              <Link to="/#contact" data-id="element-105">Contact</Link>
            </div>

            <div data-id="element-106">
              <h5 data-id="element-107">Services</h5>
              <Link to="/#contact" data-id="element-108">Branding</Link>
              <Link to="/#contact" data-id="element-109">Web design & build</Link>
              <Link to="/#contact" data-id="element-110">Marketing</Link>
              <Link to="/#contact" data-id="element-111">Creative consulting</Link>
            </div>

            <div data-id="element-112">
              <h5 data-id="element-113">Contact</h5>
              <a href="mailto:info@yetudesignlab.com" data-id="element-114">info@yetudesignlab.com</a>
              <a href="tel:0701922299" data-id="element-115">0701 922 299</a>
              <a href="https://maps.google.com/?q=Kilimani,+Nairobi,+Kenya" target="_blank" rel="noopener noreferrer" data-id="element-116">
                Kilimani, Nairobi, Kenya
              </a>
            </div>
          </div>

          <div className="ft__bottom" data-id="element-117">
            <span data-id="element-118">© {year} Yetu Design Lab. All rights reserved.</span>
            <div className="flex items-center gap-5 flex-wrap" data-id="element-119">
              <ThemeToggle data-id="element-120" />
              <span className="made" data-id="element-121">Made in Nairobi</span>
            </div>
          </div>
        </div>
      </footer>
    </>;
}